import styled from "@emotion/styled";

const PREFIX = "FormStyles";
export const formClasses = {
  root: `${PREFIX}-root`,
  rootLarge: `${PREFIX}-rootLarge`,
  formControl: `${PREFIX}-formControl`,
  submit: `${PREFIX}-submit`,
  profileImage: `${PREFIX}-profileImage`,
  titleHeader: `${PREFIX}-titleHeader`,
  subHheader: `${PREFIX}-subHheader`,
  date: `${PREFIX}-date`,
  submitBtn: `${PREFIX}-submitBtn`,
  sectionProfileTitle: `${PREFIX}-sectionProfileTitle`,
  sectionMainTitle: `${PREFIX}-sectionMainTitle`,
  delimiter: `${PREFIX}-delimiter`,
  sectionSubTitle: `${PREFIX}-sectionSubTitle`,
  alert: `${PREFIX}-alert`,
  helpButton: `${PREFIX}-helpButton`,
  tooltip: `${PREFIX}-tooltip`,
  longFormLabelContainer: `${PREFIX}-longFormLabelContainer`,
  sparse: `${PREFIX}-sparse`,
  longFormLabel: `${PREFIX}-longFormLabel`,
  dropdownBackground: `${PREFIX}-dropdownBackground`,
  dropdownItem: `${PREFIX}-dropdownItem`,
  largeFont: `${PREFIX}-largeFont`,
  chips: `${PREFIX}-chips`,
  chip: `${PREFIX}-chip`,
  sectionTitle: `${PREFIX}-sectionTitle`,
  switch: `${PREFIX}-switch`,
  switchRoot: `${PREFIX}-switchRoot`,
  asipCard: `${PREFIX}-asipCard`,
  asipCardContent: `${PREFIX}-asipCardContent`,
  asipCardGrid: `${PREFIX}-asipCardGrid`,
  asipTextField: `${PREFIX}-asipTextField`,
  asipSubmitContainer: `${PREFIX}-asipSubmitContainer`,
  asipSubmit: `${PREFIX}-asipSubmit`,
  asipImgContainer: `${PREFIX}-asipImgContainer`,
  asipQuestionContainer: `${PREFIX}-asipQuestionContainer`,
  textAreaRoot: `${PREFIX}-textAreaRoot`,
  textAreaCharCounter: `${PREFIX}-textAreaCharCounter`,
  textAreaCharCounterMax: `${PREFIX}-textAreaCharCounterMax`,
};
export const FormRoot = styled("form")(({ theme }) => ({
  [`&.${formClasses.root}`]: {
    "& .MuiTextField-root": {
      margin: `8px 0px;`,
    },
  },
  [`& .${formClasses.rootLarge}`]: {
    "& .MuiTextField-root": {
      margin: `16px 0px;`,
    },
  },
  [`& .${formClasses.formControl}`]: {
    minWidth: "100%",
    margin: `16px 0px;`,
  },
  [`& .${formClasses.submit}`]: {
    marginTop: "12px",
    marginBottom: "16px",
    width: "194px",
    "@media (max-width: 1000px)": {
      width: "100%",
    },
  },
  [`& .${formClasses.profileImage}`]: {
    cursor: "pointer",
  },
  [`& .${formClasses.titleHeader}`]: {
    display: "flex",
    justifyItems: "center",
    justifyContent: "center",
    marginBottom: "30px",
  },
  [`& .${formClasses.subHheader}`]: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    marginTop: 10,
  },
  [`& .${formClasses.date}`]: {
    marginLeft: "10px",
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.4)",
  },
  [`& .${formClasses.submitBtn}`]: {
    marginTop: "25px",
    marginBottom: "16px",
    fontFamily: "Helvetica Neue",
    color: "#001E43",
    fontWeight: "bold",
    backgroundColor: "#FFA654",
  },
  [`& .${formClasses.sectionProfileTitle}`]: {
    fontWeight: 700,
    fontSize: 48,
    padding: "0 0 40px 0",
    color: "#393C74",
  },
  [`& .${formClasses.sectionMainTitle}`]: {
    fontWeight: 500,
    fontSize: 28,
    paddingLeft: 0,
    marginBottom: 12,
    color: "#000000",
  },
  [`& .${formClasses.delimiter}`]: {
    border: "1px",
    borderStyle: "solid",
    borderColor: "rgb(205, 218, 221)",
    margin: "40px 0",
    width: "100%",
  },
  [`& .${formClasses.sectionSubTitle}`]: {
    fontWeight: "bold",
    fontSize: 18,
    paddingLeft: 0,
    marginBottom: 12,
    color: "#000000",
  },
  [`& .${formClasses.alert}`]: {
    borderRadius: "24px !important",
    padding: "6px 24px",
    marginTop: "12px ",
  },
  [`& .${formClasses.helpButton}`]: {
    fontSize: "24px",
    cursor: "pointer",
    color: "#5db2e3",
  },
  [`& .${formClasses.tooltip}`]: {
    fontSize: "16px",
  },
  [`& .${formClasses.longFormLabelContainer}`]: {
    position: "relative",
    padding: "2px 0",
  },
  [`& .${formClasses.sparse}`]: {
    marginTop: "24px",
  },
  [`& .${formClasses.longFormLabel}`]: {
    fontSize: "16px",
    marginBottom: "8px",
    paddingLeft: 0,
    width: "100%",
  },
  [`& .${formClasses.dropdownBackground}`]: {
    position: "relative",
    maxWidth: "300px !important",
  },
  [`& .${formClasses.dropdownItem}`]: {
    height: "100px",
  },
  [`& .${formClasses.largeFont}`]: {
    fontSize: 24,
  },
  [`& .${formClasses.chips}`]: {
    display: "flex",
    flexWrap: "wrap",
  },
  [`& .${formClasses.chip}`]: { margin: 2 },
  [`& .${formClasses.sectionTitle}`]: {
    fontWeight: "bold",
    fontSize: 18,
    paddingLeft: 0,
    marginBottom: 12,
  },
  [`& .${formClasses.switch}`]: { fontSize: "16px !important" },
  [`& .${formClasses.switchRoot}`]: { marginBottom: 24 },
  [`& .${formClasses.asipCard}`]: {
    backgroundColor: "#E4EAEB",
    borderRadius: 24,
  },
  [`& .${formClasses.asipCardContent}`]: { paddingBottom: 16 },
  [`& .${formClasses.asipCardGrid}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media (max-width: 600px)": {
      justifyContent: "center",
      flexDirection: "column",
    },
  },
  [`& .${formClasses.asipTextField}`]: {
    backgroundColor: "white",
    borderRadius: 24,
  },
  [`& .${formClasses.asipSubmitContainer}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
    "@media (max-width: 600px)": {
      justifyContent: "center",
      flexDirection: "column",
    },
  },
  [`& .${formClasses.asipSubmit}`]: {
    marginLeft: "12",
    backgroundColor: "#3E4066",
    margin: 0,
    minWidth: 150,
    "@media (max-width: 600px)": {
      marginLeft: 0,
      marginTop: 16,
      width: "100%",
    },
  },
  [`& .${formClasses.asipImgContainer}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  [`& .${formClasses.longFormLabelContainer}`]: { width: "100%" },
  [`& .${formClasses.asipQuestionContainer}`]: { width: "100%" },
  [`& .${formClasses.textAreaRoot}`]: { position: "relative" },
  [`& .${formClasses.textAreaCharCounter}`]: {
    position: "absolute",
    bottom: 8,
    right: 18,
    pointerEvents: "none",
  },
  [`& .${formClasses.textAreaCharCounterMax}`]: { color: "#ea4335" },
}));
